import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@/core/store";
import { CartItem } from "@/domains/shop/constants/cartItem";
import { GoodsItem } from "@/domains/shop/constants/goodsItem";

export interface GoodsList {
  brand: string;
  cash: number;
  card: number;
  data: GoodsItem[];
}

export type ShopState = {
  isShow: boolean;
  shopId: number;
  goodsData: GoodsList;
  cartData: CartItem[];
};

const initialState: ShopState = {
  isShow: false,
  shopId: null,
  goodsData: { brand: "", cash: 0, card: 0, data: [] },
  cartData: [],
};

const shopSlice = createSlice({
  name: "shopSlice",
  initialState,
  reducers: {
    clearSlice(state) {
      state.isShow = false;
      state.shopId = null;
      state.goodsData = { brand: "", cash: 0, card: 0, data: [] };
      state.cartData = [];
    },
    showShop(state, action: PayloadAction<number>) {
      state.isShow = true;
      state.shopId = action.payload;
    },
    hideShop(state) {
      state.isShow = false;
      state.shopId = null;
    },
    addGoodsInCart(state, action: PayloadAction<GoodsItem>) {
      const existingItem = state.cartData.find((item) => item.id === action.payload.id);

      if (existingItem) {
        existingItem.count += 1;
      } else {
        state.cartData.push({
          ...action.payload,
          count: 1,
        });
      }
    },
    incrementGoodsInCart(state, action: PayloadAction<number>) {
      const existingItem = state.cartData.find((item) => item.id === action.payload);
      existingItem.count += 1;
    },
    decrementGoodsInCart(state, action: PayloadAction<number>) {
      const existingItem = state.cartData.find((item) => item.id === action.payload);
      if (existingItem.count > 1) {
        existingItem.count -= 1;
      } else {
        state.cartData = state.cartData.filter((item) => item.id !== action.payload);
      }
    },
    removeGoodsFromCart(state, action: PayloadAction<number>) {
      state.cartData = state.cartData.filter((item) => item.id !== action.payload);
    },
    clearCart(state) {
      state.cartData = [];
    },
  },
});

export const isShowShop = (state: RootState) => state.shop.isShow;
export const shopIdSelector = (state: RootState) => state.shop.shopId;
export const goodsData = (state: RootState) => state.shop.goodsData;
export const cartData = (state: RootState) => state.shop.cartData;
export const shopReducer = shopSlice.reducer;
export const {
  clearSlice,
  showShop,
  hideShop,
  addGoodsInCart,
  incrementGoodsInCart,
  decrementGoodsInCart,
  removeGoodsFromCart,
  clearCart,
} = shopSlice.actions;
